'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import MenuClose from '@/assets/svg/menu/x.svg';
import MenuBurger from '@/assets/svg/menu/hamburger.svg';
import SvgLogo from '@/assets/svg/clayton-built-logo-white.svg';
import MobileHeader from './MobileHeader/MobileHeader';
import DesktopHeader from './DesktopHeader/DesktopHeader';
import {
  globalLayerIndex,
  setLayerBelow,
  setLayerSameAs,
} from '@/utils/zIndex';

const zIndicies = {
  entireComponent: setLayerBelow(globalLayerIndex.dropDownMenuModal),
  navMenuItemsDesktop: setLayerSameAs(),
  navLogoBurgerMobile: setLayerSameAs(),
  navMenuItemsMobile: setLayerBelow(),
};

if (
  typeof window !== 'undefined' &&
  typeof document !== 'undefined' &&
  !document.getElementById('ccpa_script')
) {
  let source = `https://privacy.claytonhomes.com/ccpa/v5/index.min.js`;
  let script = document.createElement('script');
  script.src = source;
  script.defer = true;
  script.id = 'ccpa_script';
  script.setAttribute('data-id', 'ccpa-banner');
  script.setAttribute('data-first-link-text', 'Privacy Policy');
  script.setAttribute(
    'data-first-link-href',
    'https://www.claytonhomes.com/privacy/'
  );
  document.getElementsByTagName('head')[0]?.appendChild(script);
}

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);
  const handleCloseNavigator = () => {
    setNavOpen(false);
  };

  return (
    <header
      className={`z-[${zIndicies.entireComponent}] static h-20 w-full bg-hbg-blue pt-[5px] shadow-md`}
    >
      <div className="relative smDesktop:mx-auto smDesktop:my-0">
        <div className="flex w-full flex-col">
          <div
            className={`mt-[-7px] flex h-20 w-full justify-between smDesktop:border-b-0 z-[${zIndicies.navLogoBurgerMobile}]`}
          >
            <div className="mx-[15px] mb-0 mt-2 flex cursor-pointer flex-wrap items-center justify-between">
              <Link href="/">
                <SvgLogo
                  alt="Clayton Home Building Group logo"
                  data-testid="cb-logo-header"
                />
              </Link>
            </div>
            <button
              aria-controls="main-menu"
              className="mb-0 ml-[7px] mr-0 mt-2 cursor-pointer border-none smDesktop:hidden"
              data-testid="nav-burger-button"
              onClick={() => setNavOpen(!navOpen)}
            >
              {navOpen ? (
                <MenuClose className="h-10 w-10 *:scale-[2.5] *:fill-white" />
              ) : (
                <MenuBurger className="h-10 w-10 *:scale-[2.5] *:fill-white" />
              )}
            </button>
          </div>
          <div
            className={`${navOpen ? 'mt-[73px]' : 'mt-[-1800px]'} absolute mx-auto mb-0 w-full bg-hbg-blue py-[25px] shadow-md z-[${zIndicies.navMenuItemsMobile}] smDesktop:right-0 smDesktop:top-0 smDesktop:flex smDesktop:w-[calc(100%_-_220px)] smDesktop:flex-wrap smDesktop:justify-between smDesktop:bg-transparent smDesktop:p-0 smDesktop:shadow-none z-[${zIndicies.navMenuItemsDesktop}] smDesktop:mt-0`}
          >
            <div className="mx-auto my-0 w-mobile smDesktop:w-full">
              <MobileHeader handleCloseNavigator={handleCloseNavigator} />
              <DesktopHeader />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
